import { render, staticRenderFns } from "./SuccessfulFlowDownSubmissionView.vue?vue&type=template&id=50e578c8"
import script from "./SuccessfulFlowDownSubmissionView.vue?vue&type=script&lang=js"
export * from "./SuccessfulFlowDownSubmissionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports